// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as JsxRuntime from "react/jsx-runtime";

function GrpcFieldErrorWrapper(Props) {
  let errors = Props.errors;
  let field = Props.field;
  let children = Props.children;
  const errorText = Belt__Belt_List.getBy(errors, (function (error) {
    return error.field === field;
  }));
  return JsxRuntime.jsxs("div", {
    children: [
      children,
      errorText !== undefined ? JsxRuntime.jsx("span", {
          children: errorText.description,
          className: "mt-2 text-sm text-red-600"
        }) : null
    ]
  });
}

const make = GrpcFieldErrorWrapper;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
